<script setup lang="ts">
import { computed } from 'vue';
import { LoanType } from '@/helpers/const';
import { pluralise } from '@/helpers/pluralise';
import { useRequestIncomeExpenseProcess } from '@/helpers/useRequestIncomeExpenseProcess';
import ApplicantSummary from './ApplicantSummary.vue';
import BuyingSummary from './BuyingSummary.vue';
import LoanDetailSummary from './LoanDetailSummary.vue';
import PropertyOwnershipSummary from './PropertyOwnershipSummary.vue';
import SellingSummary from './SellingSummary.vue';

const { loanApp, loanProperties, loanApplicants } = useRequestIncomeExpenseProcess();

const isErhl = computed(() => loanApp.value.lendingProduct === 'erhl');

const loanPurpose = computed(() => {
  if (isErhl.value) return 'Equity Release Home Loan';
  return loanApp.value.loanType === LoanType.BRIDGING ? 'Buy now, sell later' : 'Unlock equity before I sell';
});

const supportingPropertyCount = computed(() => loanApp.value.supportingProperties.length);

const hideAdditionalFunds = computed(() => isErhl.value && loanApp.value.incomingProperties.length === 0);
</script>

<template>
  <div>
    <section class="summary-details">
      <h2>Loan Purpose</h2>
      <h3>Loan type</h3>
      <dl>
        <dt>Your loan purpose</dt>
        <dd>{{ loanPurpose }}</dd>
      </dl>
    </section>

    <BuyingSummary :data="loanApp.incomingProperties" :settlement-date="loanApp.settlementDate || ''" />
    <SellingSummary v-if="!isErhl" :data="loanApp.outgoingProperties" />

    <section v-if="isErhl" class="summary-details">
      <h2>Properties</h2>
      <h3>Number of properties</h3>
      <dl>
        <dt>How many existing properties are part of this loan application?</dt>
        <dd>{{ pluralise(supportingPropertyCount, 'property', 'properties') }}</dd>
      </dl>
    </section>

    <LoanDetailSummary
      v-if="loanApp.loanDetails"
      :data="loanApp.loanDetails"
      :hide-additional-funds="hideAdditionalFunds"
    />
    <ApplicantSummary :data="loanApp.applicants" />
    <PropertyOwnershipSummary
      :data="loanApp.propertiesOwnership"
      :properties="loanProperties"
      :applicants="loanApplicants"
      :is-erhl="isErhl"
    />
    <!-- <IncomeSummary :data="loanApp.financials" :applicants="loanApplicants" /> -->
  </div>
</template>
